(function () {
  'use strict';

  class ConfirmImportTtcModalCtrl {
    constructor($uibModalInstance) {
      this.modalInstance = $uibModalInstance;
    }

    confirmar() {
      this.modalInstance.close();
    }

    cancel() {
      this.modalInstance.dismiss();
    }
  }

  angular
    .module('uos')
    .controller('ConfirmImportTtcModalCtrl', ConfirmImportTtcModalCtrl);
}());

